export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系与反馈
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            如有资源建议、内容反馈或商务合作需求，欢迎通过以下方式联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 text-center">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
              <i className="ri-mail-send-line text-primary-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
              期待您的来信
            </h3>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              如果您在使用91影视看片下载的过程中有任何建议，或是对天美麻花星空影视免费观看专区的内容有需求反馈，请随时通过以下邮箱与我们取得联系。我们会在第一时间回复您的消息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#"
                className="flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                发送邮件联系
              </a>
              <a
                href="#faq"
                className="flex items-center gap-2 px-6 py-3 bg-background-200 hover:bg-background-300 text-foreground-700 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center"></i>
                查看常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}